/**
 * Put text on the clipboard, wherever the page happens to be running.
 *
 * `navigator.clipboard` is refused outside a secure context, which plain http on
 * a hostname that is not localhost is not. The fallback keeps the button honest
 * rather than silently doing nothing, which is the failure people never report
 * because it looks like nothing happened.
 */
export async function copyText(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    return;
  } catch {
    // Fall through.
  }

  const field = document.createElement("textarea");
  field.value = text;
  field.style.position = "fixed";
  field.style.opacity = "0";
  document.body.append(field);
  field.select();
  try {
    document.execCommand("copy");
  } finally {
    field.remove();
  }
}
